import { IsInstanceOf } from "@utils/class-validator/class-validator-constraints";
import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsOptional, IsString, ValidateNested } from "class-validator";

export class ChecklistItem {
  @IsBoolean()
  checked: boolean = false;

  @IsOptional()
  @IsString()
  notes?: string;
}

export class ChecklistItemSingleChoice {
  @IsBoolean()
  checked: boolean = false;

  @IsOptional()
  @IsString()
  choice?: string;
}

export class ChecklistItemMultipleChoice {
  @IsBoolean()
  checked: boolean = false;

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  choices?: string[];
}

export class ChecklistItemSecondaryDisplays {
  @IsBoolean()
  checked: boolean = false;

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  choices?: string[];

  @IsOptional()
  @IsString()
  networkChoice?: string;

  @IsOptional()
  @IsString()
  connectionToChoice?: string;

  @IsOptional()
  @IsString()
  notes?: string;
}

export class ChecklistMonitoring {
  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  existingInstallBase: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItemSingleChoice)
  @ValidateNested()
  @IsInstanceOf(ChecklistItemSingleChoice)
  networked: ChecklistItemSingleChoice = new ChecklistItemSingleChoice();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  networkCableSupply: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  wirelessNetworkRequired: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  deviceInterfacingRequired: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItemMultipleChoice)
  @ValidateNested()
  @IsInstanceOf(ChecklistItemMultipleChoice)
  centralStationIncluded: ChecklistItemMultipleChoice = new ChecklistItemMultipleChoice();

  @Type(() => ChecklistItemSecondaryDisplays)
  @ValidateNested()
  @IsInstanceOf(ChecklistItemSecondaryDisplays)
  secondaryDisplaysIncluded: ChecklistItemSecondaryDisplays = new ChecklistItemSecondaryDisplays();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  ownPrinter: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItemMultipleChoice)
  @ValidateNested()
  @IsInstanceOf(ChecklistItemMultipleChoice)
  itAppsIncluded: ChecklistItemMultipleChoice = new ChecklistItemMultipleChoice();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  digitalSolutionsIncluded: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItemSingleChoice)
  @ValidateNested()
  @IsInstanceOf(ChecklistItemSingleChoice)
  serverLocation: ChecklistItemSingleChoice = new ChecklistItemSingleChoice();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  additionalInformation: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItemSingleChoice)
  @ValidateNested()
  @IsInstanceOf(ChecklistItemSingleChoice)
  mountInstaller: ChecklistItemSingleChoice = new ChecklistItemSingleChoice();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  earlyChannelSupply: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItemSingleChoice)
  @ValidateNested()
  @IsInstanceOf(ChecklistItemSingleChoice)
  earlyItInvolvementRequired: ChecklistItemSingleChoice = new ChecklistItemSingleChoice();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  ipAddressRangeProvided: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  departmentNamesProvided: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  bedNamesProvided: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  hospitalShortNameProvided: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  hospitalPrinterIpsProvided: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItemSingleChoice)
  @ValidateNested()
  @IsInstanceOf(ChecklistItemSingleChoice)
  commissioningRequirementsProvided: ChecklistItemSingleChoice = new ChecklistItemSingleChoice();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  deliveryDetails: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  estimatedGoLiveDate: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  additionalInstallationInformation: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  deadlineRisks: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  technicalRisks: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  otherRisks: ChecklistItem = new ChecklistItem();

  @Type(() => ChecklistItem)
  @ValidateNested()
  @IsInstanceOf(ChecklistItem)
  discussionNotes: ChecklistItem = new ChecklistItem();
}
